import * as React from 'react';

import CampaignModulesDataProviderForXdp from 'bundles/campaigns/providers/CampaignModulesDataProviderForXdp';
import { savedProductTypes } from 'bundles/unified-description-page-common/constants';
import SubscriptionsForwardDiscoveryDataProvider from 'bundles/unified-description-page-common/providers/SubscriptionsForwardDiscoveryDataProvider';
import AliceProvider from 'bundles/unified-description-page-common/providers/consumer/AliceProvider';
import { SpecializationArticlesRecsDataProvider } from 'bundles/unified-description-page-common/providers/consumer/ArticlesRecommendationsDataProvider';
import CareerRolesDataProvider from 'bundles/unified-description-page-common/providers/consumer/CareerRolesDataProvider';
import { SpecializationCourseraPlusOwnershipDataProvider } from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusOwnershipDataProvider';
import CourseraPlusSavedProductDataProvider from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusSavedProductDataProvider';
import RelatedProgramsDataProvider from 'bundles/unified-description-page-common/providers/consumer/RelatedProgramsDataProvider';
import ConsumerBffSpecializationDataProvider from 'bundles/unified-description-page-common/providers/consumer/bff/ConsumerBffSpecializationDataProvider';
import RecommendationsDataProvider from 'bundles/unified-description-page-common/providers/specialization/RecommendationsDataProvider';
import SpecializationDegreeCollectionDataProvider from 'bundles/unified-description-page-common/providers/specialization/SpecializationDegreeCollectionDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

type Props = {
  children: React.ReactNode;
};

const ConsumerSpecializationPageDataProvider = ({ children }: Props) => {
  return (
    <ConsumerBffSpecializationDataProvider>
      <CampaignModulesDataProviderForXdp>
        <AliceProvider>
          <UserDataProvider includeOpenCourseMemberships>
            <SpecializationCourseraPlusOwnershipDataProvider>
              <CourseraPlusSavedProductDataProvider savedProductType={savedProductTypes.SPECIALIZATION}>
                <SpecializationArticlesRecsDataProvider>
                  <CareerRolesDataProvider>
                    <RelatedProgramsDataProvider>
                      <SpecializationDegreeCollectionDataProvider>
                        <SubscriptionsForwardDiscoveryDataProvider>
                          <RecommendationsDataProvider productVariant="specialization">
                            {children}
                          </RecommendationsDataProvider>
                        </SubscriptionsForwardDiscoveryDataProvider>
                      </SpecializationDegreeCollectionDataProvider>
                    </RelatedProgramsDataProvider>
                  </CareerRolesDataProvider>
                </SpecializationArticlesRecsDataProvider>
              </CourseraPlusSavedProductDataProvider>
            </SpecializationCourseraPlusOwnershipDataProvider>
          </UserDataProvider>
        </AliceProvider>
      </CampaignModulesDataProviderForXdp>
    </ConsumerBffSpecializationDataProvider>
  );
};

export default ConsumerSpecializationPageDataProvider;
